import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { configureStore } from "@reduxjs/toolkit";

interface AvatarState {
  url: string;
}

const initialState: AvatarState = {
  url: "",
};

const avatarSlice = createSlice({
  name: "avatar",
  initialState,
  reducers: {
    setAvatarUrl(state, action: PayloadAction<string>) {
      state.url = action.payload;
    },
  },
});

export const { setAvatarUrl } = avatarSlice.actions;

export default avatarSlice.reducer;
